import { makeStyles, colors } from "@material-ui/core";

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      textTransform: "none",
      borderRadius: 2,

      "&.MuiButton-containedPrimary": {
        "&:hover": {
          opacity: 0.9,
          backgroundColor: theme.palette.primary.main,
        },
      },
      "&.MuiButton-containedSecondary": {
        "&:hover": {
          opacity: 0.9,
          backgroundColor: theme.palette.secondary.main,
        },
      },
      "&.Mui-disabled": {
        border: `1px solid ${colors.grey[200]}`,
        backgroundColor: colors.grey[100],
      },
    },
  }),
  { name: "input-button-style", flip: null }
);
